<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flex-spc-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="postion:fixed">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>基础设置</el-breadcrumb-item>
      </el-breadcrumb>
      <el-link type="primary" style="margin-right:220px" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </div>
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
    
      <el-link type="primary" style="float:right" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </el-breadcrumb> -->
     <div>
       <div class="flex-spc-x" style="width:100%;padding-top:30px;">
            <el-table
                             :data="ListOverallSetting"
                             tooltip-effect="dark"
                             border
                             stripe
                             style="width: 100%">
                            <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
                             <el-table-column label="名称"  width="300" prop="name"></el-table-column>
                            <el-table-column  label="功能介绍"  >
                                 <template slot-scope="scope">
                                  <span> {{scope.row.info}}</span>
                            </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center" width="100">
                            <template slot-scope="scope">
                              <el-switch  
                                v-model="scope.row.Ison"
                                on-color="#00A854"
                                on-text="启动"
                                on-value="1"
                                off-color="#F04134"
                                off-text="禁止"
                                off-value="0"
                                @change="changeSwitch(scope.row)">
                              </el-switch>
                              <!-- <el-button type="text" @click="toEdit(scope.row)">编辑</el-button> -->
                            </template>
                 </el-table-column>
            </el-table>
          <el-dialog title="停卡" :visible.sync="show" width="40%">
            <div slot="footer" class="dialog-footer">
              <el-button size="small" @click="show = false">取消</el-button>
              <el-button size="small" type="primary" :loading="loading"  @click="sure()">确认</el-button>
            </div>
          </el-dialog>
    </div>
    </div>
    </div> 
</template>
<script>
import CropperImage from "../../components/CropperImage";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
 
    DianList:[],
    SelectStoresID:localStorage.getItem("StoresID"),
    tableLoading:false,
    overtype:0,
    show:false,
    ListOverallSetting:[],
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      }
    
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    toEdit(row){
        this.show = true
    },
      tosetting(){
         this.$router.push({ path: '/setting/setting'})
      } ,
      getList(){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
    
      }
     
      
        var that = this
      this.ajax('getListOverallSetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.ListOverallSetting = res.data
            for (let i = 0; i < res.data.length; i++) {
                        
                        if(res.data[i].Ison =='1'){
                        that.ListOverallSetting[i].Ison = true;

                        }else{
                        that.ListOverallSetting[i].Ison = false;

                        }
                    }
          } 

      })
  
  
    },changeSwitch(val){
                 this.overtype = val.sType;
                 let ison = 0;
               if(val.Ison){
                   ison =1;
               }else{

                   ison =0;
               }

               this.editOverallSettingIson(val.ID , ison);
            }, editOverallSettingIson(SttingID,Ison){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SttingID:SttingID,
          Ison:Ison
         }
     
      
        var that = this
         this.ajax('editOverallSettingIson.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
                if(that.overtype == 9){
                
                   localStorage.setItem("isshowGM",Ison);
                }else if(that.overtype ==15 ){

                localStorage.setItem("isweekdays",Ison);
               }
                
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

            },

            
            
   
  }
}
</script>
 


// WEBPACK FOOTER //
// src/views/setting/OverallSettingInfo.vue